import { useMutation } from '@tanstack/react-query';
import { push } from 'connected-react-router';
import { store } from '../../..';
import { r } from '../../../routes';
import { getBasePath } from '../../../utils/global';
import { coreClient } from '../../../utils/request';
import { retrieveCurrentUser } from '../utils/retrieveCurrentUser';

export interface LoginCreds {
  email: string;
  password: string;
}

export interface UseLoginResult {
  mutate: (creds: LoginCreds) => void;
  isPending: boolean;
  error: Error | null;
}

/**
 * POST /login, refresh profile, mark manual session in Redux, then same navigation as the old afterLogin saga.
 */
export function useLogin(): UseLoginResult {
  const l = new URL(window.location.href);
  const mutation = useMutation({
    mutationFn: coreClient.users.login,
    onSuccess: async () => {
      await retrieveCurrentUser();
      afterLoginRedirect();
    },
  });

  const mutate = (creds: LoginCreds): void => {
    const trId = l.searchParams.get('transport_request') ?? undefined;
    mutation.mutate({
      ...creds,
      trId,
    });
  };

  return {
    mutate,
    isPending: mutation.isPending,
    error: mutation.error ?? null,
  };
}

export function afterLoginRedirect(): void {
  const l = new URL(window.location.href);
  const afterSuccessRedirect = l.searchParams.get('after_success_redirect');
  if (l.searchParams.get('contact') === 'true') {
    window.location.assign(getBasePath() + r.generalFlow.contact.index());
    return;
  }
  if (afterSuccessRedirect) {
    window.location.assign(decodeURIComponent(afterSuccessRedirect));
    return;
  }
  store.dispatch(push(r.user.dashboard()));
}
